let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3ZFtq")).then(() => parcelRequire('eNWU9'));